import React from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import cn from 'classnames'

import { useTranslation } from '@mc/i18n'

import { useIsOnboardingEnabled } from '../../experiments/dais-3595_v1_onboarding'
import { paths } from '../../utils/paths'
import { getRoleplayActiveTab, ROLEPLAY_NAV_TABS } from '../../utils/roleplay'
import { usePersonaEvents } from '../../events'

import styles from './NavBar.module.scss'

export const RoleplayTabs = ({ className = '' }: { className?: string }) => {
  const { pathname } = useRouter()
  const { t } = useTranslation('@mc/persona')
  const roleplayActiveTab = getRoleplayActiveTab(pathname)
  const { trackPersonaClick } = usePersonaEvents()
  const isForYouEnabled = useIsOnboardingEnabled()

  const handleClick = (cta: string) => {
    trackPersonaClick({
      cta,
      location: 'tab navigation',
      action: 'navigation clicked',
    })
  }

  return (
    <div
      className={`d-flex flex-gap-8 align-items-center justify-content-center flex-1 ${className}`}
    >
      {isForYouEnabled && (
        <Link
          className={cn(
            'mc-text--bold',
            {
              'mc-opacity--muted':
                roleplayActiveTab !== ROLEPLAY_NAV_TABS.FOR_YOU,
            },
            styles.tab,
          )}
          href={paths.forYou}
          onClick={() => handleClick('for-you')}
        >
          {t('common.forYou')}
        </Link>
      )}
      <Link
        className={cn(
          'mc-text--bold',
          {
            'mc-opacity--muted':
              roleplayActiveTab !== ROLEPLAY_NAV_TABS.COACHES,
          },
          styles.tab,
        )}
        href={paths.coaches}
        onClick={() => handleClick('coaches')}
      >
        {t('common.coaches')}
      </Link>
      <Link
        className={cn(
          'mc-text--bold',
          {
            'mc-opacity--muted':
              roleplayActiveTab !== ROLEPLAY_NAV_TABS.ROLEPLAY,
          },
          styles.tab,
        )}
        href={paths.roleplay}
        onClick={() => handleClick('roleplay')}
      >
        {t('common.roleplay')}
      </Link>
    </div>
  )
}
